import {
  ERROR_403_MESSAGE,
  ERROR_UNAUTH_MSG,
  LOGGED_OUT_MSG
} from "../../services/constants";
import {
  SHOW_SNACKBAR,
  SHOW_SUCCESS_SNACKBAR,
  SHOW_GENERIC_SNACKBAR,
  RESET_SNACKBAR_MESSAGE
} from "./snackbarActionTypes";

// Auto-hide duration (10 seconds)
const AUTO_HIDE_DURATION = 10000;

// Store timeout ID for error snackbar
let errorTimeoutId = null;

export const showSnackBar = error => {
  return dispatch => {
    // Clear any existing timeout
    if (errorTimeoutId) {
      clearTimeout(errorTimeoutId);
    }

    if (error == ERROR_403_MESSAGE) {
      dispatch({
        type: SHOW_GENERIC_SNACKBAR,
        snackBarStatus: true,
        snackBarGenericMsg: LOGGED_OUT_MSG
      });
    } else {
      dispatch({
        type: SHOW_SNACKBAR,
        snackBarStatus: true,
        resultMsg: error
      });

      // Auto-hide after 10 seconds
      errorTimeoutId = setTimeout(() => {
        dispatch(hideSnackBar());
      }, AUTO_HIDE_DURATION);
    }
  };
};

export const hideSnackBar = () => {
  // Clear timeout when manually hiding
  if (errorTimeoutId) {
    clearTimeout(errorTimeoutId);
    errorTimeoutId = null;
  }

  return {
    type: SHOW_SNACKBAR,
    snackBarStatus: false,
    resultMsg: ""
  };
};

export function showSuccessSnackBar(
  message,
  isReset = false,
  isUndo = false,
  undoOnclick
) {
  return {
    type: SHOW_SUCCESS_SNACKBAR,
    snackBarStatus: true,
    snackBarSuccessMsg: message,
    isReset,
    isUndo,
    undoOnclick
  };
}

export function hideSuccessnackBar() {
  const snackBarStatus = false;
  const snackBarSuccessMsg = "";
  return {
    type: SHOW_SUCCESS_SNACKBAR,
    snackBarStatus,
    snackBarSuccessMsg,
    isReset: false
  };
}

export function showGenericSnackBar(message) {
  return {
    type: SHOW_GENERIC_SNACKBAR,
    snackBarStatus: true,
    snackBarGenericMsg: message
  };
}

export function hideGenericSnackBar() {
  const snackBarStatus = false;
  const snackBarGenericMsg = "";
  return {
    type: SHOW_GENERIC_SNACKBAR,
    snackBarStatus,
    snackBarGenericMsg
  };
}

// Reset snackbar message after showing in toast
export function resetSnackbarMessage() {
  return {
    type: RESET_SNACKBAR_MESSAGE
  };
}
